/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import BaseProductTemplate from '@bottlebooks/gatsby-theme-event-pages/src/templates/ProductTemplate';
import { graphql as gatsbyGraphQL } from 'gatsby';
import { jsx } from 'theme-ui';
import addPriceRange from '../../../addPriceRange';

export default function ProductTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  return (
    <BaseProductTemplate
      data={afterQuery(data)}
      pageContext={pageContext}
      location={location}
      navigate={navigate}
    />
  );
}

export const pageQuery = gatsbyGraphQL/* GraphQL */ `
  query vv_ProductTemplate(
    $id: String!
    $productId: ID!
    $eventId: ID!
    $exhibitorId: ID!
    $locale: Bottlebooks_ContentLocale
    $previousId: String
    $nextId: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        eventId
        # Get the IDs and other data out of registeredProducts.
        registeredProducts(
          filter: {
            productId: { eq: $productId }
            partnerId: { eq: $exhibitorId }
          }
        ) {
          nodes {
            ...EventProductPage_RegisteredProduct
            pricing {
              price
            }
            registration {
              ...vv_Registration_exhibitorPackage
            }
            product {
              ...vv_ProductName
              ...vv_ProductVarieties
            }
            producer {
              products {
                nodes {
                  product {
                    productId
                    ...vv_ProductName
                  }
                }
              }
            }
          }
        }
        registrations(filter: { companyId: { eq: $exhibitorId } }) {
          nodes {
            # This is a quick fix to get the data onto the page
            ...bb_Registration
          }
        }
        product(productId: $productId, exhibitorId: $exhibitorId) {
          ...bb_EventProductPage
          ... on Bottlebooks_Wine {
            wineType(format: LOCALIZED)
          }
        }
      }
    }
    product(id: { eq: $id }) {
      id
      productId
      ...EventProductPage
      producer {
        name
        products {
          ...EventProductPage_Related
        }
      }
    }
    previous: product(id: { eq: $previousId }) {
      ...ChangeProductLink
    }
    next: product(id: { eq: $nextId }) {
      ...ChangeProductLink
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;

function afterQuery(data) {
  return {
    ...data,
    bottlebooks: {
      ...data?.bottlebooks,
      event: {
        ...data?.bottlebooks?.event,
        registeredProducts: {
          ...data?.bottlebooks?.event?.registeredProducts,
          nodes: data?.bottlebooks?.event?.registeredProducts?.nodes.map(
            (registeredProduct) =>
              wipePremiumData({
                ...registeredProduct,
                pricing: addPriceRange(registeredProduct.pricing),
              })
          ),
        },
      },
    },
  };
}

function wipePremiumData(registeredProduct) {
  // console.log(registeredProduct);
  const exhibitorPackage =
    registeredProduct?.registration?.exhibitorPackage?.key;
  if (exhibitorPackage === 'premium' || exhibitorPackage === 'pavilion') {
    return registeredProduct;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { awards: _1, onlineShop: _2, videos: _3, ...rest } = registeredProduct;
  return { ...rest, onlineShop: null, awards: null, tastingNotes: null };
}
